import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { HolidayDatesDialogComponent } from '../holiday-dates-dialog/holiday-dates-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-holiday-dates',
  templateUrl: './holiday-dates.component.html',
  styleUrls: ['./holiday-dates.component.scss']
})
export class HolidayDatesComponent implements OnInit {
  HolidayDatesForm: FormGroup;
  HolidaySearchForm
  sessionList: any;
  SessionFilterList: any;
  submitpayload: any;
  arr: [];
  DateArray: FormArray;
  Table = false;
  holidayList: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  SessionNo: any;
  isToDateEnabled: boolean = false;
  date: string;
  currentdate;
  setIntervalSearch: any;
  constructor( public umsService: UmsService,private spinner: NgxSpinnerService,
    public datepipe: DatePipe, private fb: FormBuilder,private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.date = this.datepipe.transform(this.currentdate, 'dd/MM/yyyy');
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    window.scroll(0, 0);
    this.HolidaySearchForm = this.fb.group({
      SnNo: new FormControl(''),
      FromDate: new FormControl(''),
      ToDate: new FormControl(''),
      HolidayName: new FormControl(''),
      SearchString: new FormControl('')
    });
    this.getHolidayData();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );

    // Holiday Date
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.holidayList = [];
    let payload = {}
    payload['SearchString'] = this.HolidaySearchForm.value['SearchString'];
    payload['PageSize'] = this.pageSize;
    payload['FromDate'] = '';
    payload['ToDate'] = '';
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.getSearchHoliday(payload).subscribe(res => {
      if(res.status){
        this.holidayList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.holidayList = [];
        this.totalItems = 0;
      }
     
    }, (ERROR: HttpErrorResponse) => {
      this.holidayList = [];
    });
    },1000)
   
  }
  // FromDateSearch() {
  //   this.HolidaySearchForm.value['FromDate'] = this.datepipe.transform(this.HolidaySearchForm.value['FromDate'], 'yyyy-MM-dd');
  //   this.holidayList = [];
  //   let payload = {}
  //   payload['SnNo'] = '';
  //   payload['FromDate'] = this.HolidaySearchForm.value['FromDate'];
  //   payload['PageSize'] = this.pageSize;
  //   payload['ToDate'] = '';
  //   payload['SearchString'] = '';
  //   if (payload['FromDate'] === "") {
  //     payload['PageNumber'] = this.currentPage;
  //     this.isToDateEnabled = false;
  //   } else {
  //     payload['PageNumber'] = 1;
  //     this.isToDateEnabled = true;
  //   }
  //   this.umsService.getSearchHoliday(payload).subscribe(res => {
  //     if(res.status){
  //       this.holidayList = res.data;
  //       this.totalItems = res.data[0].TotalRecords;
  //     }
  //     else{
  //       this.holidayList = [];
  //       this.totalItems = 0;
  //     }
     
  //   }, (ERROR: HttpErrorResponse) => {
  //     this.holidayList = [];
  //   });
  // }
  ToDateSearch() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.HolidaySearchForm.value['FromDate'] = this.datepipe.transform(this.HolidaySearchForm.value['FromDate'], 'yyyy-MM-dd');
      this.HolidaySearchForm.value['ToDate'] = this.datepipe.transform(this.HolidaySearchForm.value['ToDate'], 'yyyy-MM-dd');
      this.holidayList = [];
      let payload = {}
      payload['SnNo'] = '';
      payload['ToDate'] = this.HolidaySearchForm.value['ToDate'];
      payload['PageSize'] = this.pageSize;
      payload['FromDate'] = this.HolidaySearchForm.value['FromDate'];
      payload['SearchString'] = '';
      if (payload['FromDate'] === "") {
        payload['PageNumber'] = this.currentPage;
        this.isToDateEnabled = false;
      } else {
        payload['PageNumber'] = 1;
        this.isToDateEnabled = true;
      }
      this.umsService.getSearchHoliday(payload).subscribe(res => {
        if(res.status){
          this.holidayList = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else{
          this.holidayList = [];
          this.totalItems = 0;
        }
       
      }, (ERROR: HttpErrorResponse) => {
        this.holidayList = [];
      });
    },1000)
   
  }
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getHolidayData();
    this.keypress();
    // this.FromDateSearch();
    this.ToDateSearch();
  }
 
  getHolidayData() {
    this.spinner.show();
    const payload = {};
    payload['SnNo'] = '';
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['FromDate'] = '';
    payload['ToDate'] = '';
    payload['SearchString'] = '';
    this.umsService.getExamHoliday(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.holidayList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      } else {
        this.spinner.hide();
        this.totalItems = 0;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.holidayList = [];
    });
  }
  addnewrecord() {
    const dialogRef = this.dialog.open(HolidayDatesDialogComponent, {
      width: '1000px',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getHolidayData();
      this.HolidaySearchForm.controls['SearchString'].setValue('');
    });
  }
  prepopulateRecord(k) {
    const dialogRef = this.dialog.open(HolidayDatesDialogComponent, {
      width: '1000px',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getHolidayData();
      this.HolidaySearchForm.controls['SearchString'].setValue('');
    });
  }
}
